<template>
  <div>
    <b-row align-v="center" class="d-flex align-items-center">
      <b-col cols="6" class="mb-2">
        <label class="text-capitalize">{{ $tc("unit.title", 2) }}</label>
        <v-select
          :dir="$store.state.appConfig.isRTL ? 'rtl' : 'ltr'"
          :value="facilitiesFilter"
          :options="facilities"
          class="w-100"
          multiple
          append-to-body
          :calculate-position="withPopper"
          :reduce="(val) => val.value"
          @input="(val) => $emit('update:facilitiesFilter', val)"
        />
      </b-col>
      <b-col cols="6" class="mb-2">
        <label class="text-capitalize">{{ $tc("centers.title", 2) }}</label>
        <v-select
          :dir="$store.state.appConfig.isRTL ? 'rtl' : 'ltr'"
          :value="centerFilter"
          :options="centers"
          class="w-100"
          multiple
          :reduce="(val) => val.value"
          @input="(val) => $emit('update:centerFilter', val)"
          append-to-body
          :calculate-position="withPopper"
        />
      </b-col>
      <b-col cols="6" class="mb-2">
        <label class="text-capitalize">{{ $tc("sectors.title", 2) }}</label>
        <v-select
          :dir="$store.state.appConfig.isRTL ? 'rtl' : 'ltr'"
          :value="sectorFilter"
          :options="sectors"
          class="w-100"
          s
          multiple
          :reduce="(val) => val.value"
          @input="(val) => $emit('update:sectorFilter', val)"
          append-to-body
          :calculate-position="withPopper"
        />
      </b-col>
      <b-col cols="6" class="mb-2">
        <label class="text-capitalize">
          {{ $tc('region.title', 2) }}
        </label>
        <v-select
          data-cy="automatest-v-select-region"
          :dir="$store.state.appConfig.isRTL ? 'rtl' : 'ltr'"
          :options="regionOptions"
          class="w-100"
          multiple
          append-to-body
          :calculate-position="withPopper"
          :reduce="(val) => val.value"
          :value="customQueryParams.region"
          @input="updateCustomQueryParams('region', $event)"
        />
      </b-col>
      <b-col cols="6" class="mb-2">
        <label class="text-capitalize">
          {{ $tc('municipality.title', 2) }}
        </label>
        <v-select
          data-cy="automatest-v-select-municipality"
          :dir="$store.state.appConfig.isRTL ? 'rtl' : 'ltr'"
          :options="municipalityOptions"
          class="w-100"
          multiple
          append-to-body
          :calculate-position="withPopper"
          :reduce="(val) => val.value"
          :value="customQueryParams.municipality"
          @input="updateCustomQueryParams('municipality', $event)"
        />
      </b-col>
      <b-col cols="6" class="mb-2">
        <label class="text-capitalize">{{ $t("dmp.profile_name") }}</label>
        <v-select
          :dir="$store.state.appConfig.isRTL ? 'rtl' : 'ltr'"
          :value="profileFilter"
          :options="profileOptions"
          class="w-100"
          multiple
          :reduce="(val) => val.value"
          @input="(val) => $emit('update:profileFilter', val)"
          append-to-body
          :calculate-position="withPopper"
        />
      </b-col>
      <BaseSelect
        id="enabled_zones_audit"
        :cols="6"
        :label="$t('dmp.enabled_zones_audit')"
        :value="customQueryParams.enabled_zones_audit"
        @input="updateCustomQueryParams('enabled_zones_audit', $event)"
        :options="[{ value: '1', label: 'Sí' }, { value: '0', label: 'No' }]"
        :reduce="(item) => item.value"
      />
      <BaseSelect
        id="enabled_areas_audit"
        :cols="6"
        :label="$t('dmp.enabled_areas_audit')"
        :value="customQueryParams.enabled_areas_audit"
        @input="updateCustomQueryParams('enabled_areas_audit', $event)"
        :options="[{ value: '1', label: 'Sí' }, { value: '0', label: 'No' }]"
        :reduce="(item) => item.value"
      />
      <BaseDateTime
        id="created_at"
        :cols="6"
        :label="$t('date.created_at')"
        :value="customQueryParams.created_at"
        :enable-time="false"
        date-format="Y-m-d"
        mode="range"
        @input="updateCustomQueryParams('created_at', $event)"
      />
      <BaseDateTime
        id="updated_at"
        :cols="6"
        :label="$t('date.updated_at')"
        :value="customQueryParams.updated_at"
        :enable-time="false"
        date-format="Y-m-d"
        mode="range"
        @input="updateCustomQueryParams('updated_at', $event)"
      />
    </b-row>
  </div>
</template>

<script>
import { BCard, BCardHeader, BCardBody, BRow, BCol, BButton } from "bootstrap-vue";
import vSelect from "vue-select";
import popperHelper from "@/libs/popper-helper";
import { update } from "lodash";
import { BaseInput, BaseSelect, BaseDateTime } from "@/components/Form";

export default {
  components: {
    BRow,
    BCol,
    BCard,
    BCardHeader,
    BCardBody,
    BButton,
    vSelect,
    BaseInput,
    BaseSelect,
    BaseDateTime,
  },
  props: {
    searchQuery: {
      type: String,
      default: "",
    },
    facilities: {
      type: Array,
      default: () => [],
    },
    facilitiesFilter: {
      default: null,
    },
    centers: {
      type: Array,
      default: () => [],
    },
    centerFilter: {
      default: null,
    },
    sectors: {
      type: Array,
      default: () => [],
    },
    sectorFilter: {
      default: null,
    },
    profileOptions: {
      type: Array,
      default: () => [],
    },
    profileFilter: {
      type: Array,
      default: null,
    },
    customQueryParams: {
      type: Object,
      default: () => {},
    },
    regionOptions: {
      type: Array,
      default: () => [],
    },
    municipalityOptions: {
      type: Array,
      default: () => [],
    },
  },
  setup(props, { emit }) {
    const updateCustomQueryParams = (key, value) => {
      const data = {
        ...props.customQueryParams,
        [key]: value
      }

      emit('update:customQueryParams', data)
    }
    return {
      withPopper: popperHelper.withPopper,
      updateCustomQueryParams
    };
  },
};
</script>
